import { HttpErrorResponse } from '@angular/common/http';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { paymentProfilesPerPageInitial } from '../../constants';
import { PaymentProfileListItem } from '../../entities';

import * as ProfilesActions from './profiles.actions';
import { ProfilesPageParams } from './profiles.model';

export const paymentProfilesFeatureKey = 'payment-profiles';

export interface ProfilesState {
    loading: boolean;
    loaded: boolean;
    pageParams: ProfilesPageParams;
    totalElements: number;
    idsInProgress: number[];
    error: HttpErrorResponse | null;
    loadError: HttpErrorResponse | null;
}

export interface ProfilesEntityState extends EntityState<PaymentProfileListItem>, ProfilesState {}

const initialState = {
    loaded: false,
    loading: true,
    pageParams: {
        page: 0,
        size: paymentProfilesPerPageInitial
    },
    totalElements: 0,
    idsInProgress: [] as number[],
    error: null,
    loadError: null
} as ProfilesEntityState;

export const paymentProfilesAdapter: EntityAdapter<PaymentProfileListItem> =
    createEntityAdapter<PaymentProfileListItem>();

const initialPaymentProfilesState = paymentProfilesAdapter.getInitialState(initialState);

export const paymentProfilesReducer = createReducer(
    initialPaymentProfilesState,
    on(ProfilesActions.loadPaymentProfiles, (state) => ({ ...state, loading: true, error: null })),
    on(ProfilesActions.loadPaymentProfilesSuccess, (state, { response }) =>
        paymentProfilesAdapter.setAll(response.content, {
            ...state,
            loaded: true,
            loading: false,
            totalElements: response.totalElements
        })
    ),
    on(ProfilesActions.loadPaymentProfilesFailure, (state, { loadError }) => ({ ...state, loading: false, loadError })),
    on(ProfilesActions.setPageParams, (state, { pageParams }) => ({ ...state, pageParams })),
    on(ProfilesActions.deleteProfile, (state, { id }) => ({
        ...state,
        idsInProgress: [...state.idsInProgress, id],
        error: null
    })),
    on(ProfilesActions.deleteProfileSuccess, (state, { id }) =>
        paymentProfilesAdapter.removeOne(id, {
            ...state,
            idsInProgress: state.idsInProgress.filter((cId) => cId !== id)
        })
    ),
    on(ProfilesActions.deleteProfileFailure, (state, { error, id }) => ({
        ...state,
        error,
        idsInProgress: state.idsInProgress.filter((cId) => cId !== id)
    })),
    on(ProfilesActions.changeProfileStatus, (state, { id }) => ({
        ...state,
        idsInProgress: [...state.idsInProgress, id],
        error: null
    })),
    on(ProfilesActions.changeProfileStatusSuccess, (state, update) =>
        paymentProfilesAdapter.updateOne(update, {
            ...state,
            idsInProgress: state.idsInProgress.filter((cId) => cId !== update.id)
        })
    ),
    on(ProfilesActions.changeProfileStatusFailure, (state, { id, error }) => ({
        ...state,
        error,
        idsInProgress: state.idsInProgress.filter((cId) => cId !== id)
    }))
);
